import styled from 'styled-components';

const titleColor = {
  gray: '#2e3958',
  red: '#e71037',
  green: '#1eab35',
};

const dotColor = {
  gray: '#c5cad3',
  red: '#e71037',
  green: '#1eab35',
};

export const Timeline = styled.ol`
  display: flex;
  flex-direction: column;
  margin: 22px 0 28px;
  padding: 0;
  list-style: none;
`;

export const Event = styled.li`
  display: grid;
  grid-template-columns: 22px minmax(0, 1fr);
  column-gap: 12px;
`;

export const Rail = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
`;

export const Line = styled.span`
  position: absolute;
  top: 16px;
  bottom: 0;
  width: 2px;
  background: #e6e9f0;
`;

export const Dot = styled.span<{ $tone: 'gray' | 'red' | 'green' }>`
  position: relative;
  z-index: 1;
  width: 12px;
  height: 12px;
  margin-top: 4px;
  border-radius: 50%;
  background: ${({ $tone }) => dotColor[$tone]};
  box-shadow: 0 0 0 4px #fff;
`;

export const EventBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
  padding-bottom: 22px;
`;

export const EventDate = styled.span`
  color: #9aa3b5;
  font-size: 13px;
  line-height: 1.3;
`;

export const EventTitle = styled.span<{ $tone: 'gray' | 'red' | 'green' }>`
  color: ${({ $tone }) => titleColor[$tone]};
  font-size: 16px;
  font-weight: 700;
  line-height: 1.3;
`;

export const EventDescription = styled.span`
  color: #9aa3b5;
  font-size: 13px;
  line-height: 1.35;
`;

export const Actions = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;
